import { Merchant, Restaurant } from "../services/apiService/response-models";

export interface AppState {
    sidebarOpen: boolean;
    appLoaderVisible?:boolean;
    portal:PortalNames;
    tenantCode:string;
}

export interface UserInfo {
    name: string;
    roles: string[];
}

export enum PortalNames{
    PosAdmin='pos-admin',
    GolfCourse='golf-course'
}

export function PortalDes(e:PortalNames):string{
    if(e==PortalNames.PosAdmin)
    return "POS Admin";
    if(e==PortalNames.GolfCourse)
    return "Golf Course";
}